import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi } from '@core/base/base-api';
import { Organisation } from '@shared/organisation/organisation';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrganisationApiService extends BaseApi<Organisation> {
  constructor(httpClient: HttpClient) {
    super(httpClient, 'organisations');
  }

  isNameAvailable(organisationUuid: string, name: string): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.endpoint}/${organisationUuid}/name-available`, name);
  }

  isPrefixAvailable(organisationUuid: string, prefix: string): Observable<boolean> {
    return this.httpClient.post<boolean>(`${this.endpoint}/${organisationUuid}/prefix-available`, prefix);
  }

  create(): Organisation {
    return new Organisation();
  }
}
